export const accountConstants = {
    CREATE_ACCOUNT_REQUEST: 'CREATE_ACCOUNT_REQUEST',
    CREATE_ACCOUNT_SUCCESS: 'CREATE_ACCOUNT_SUCCESS',
    CREATE_ACCOUNT_FAILURE: 'CREATE_ACCOUNT_FAILURE'
}